exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".header .username {\n  padding-left: 15px;\n}\n", ""]);
